import { formatRelative } from 'date-fns';
import { enUS } from 'date-fns/locale';

const formatRelativeLocale = {
    lastWeek: "'",
    yesterday: "'Yesterday'",
    today: "'Today'",
    tomorrow: "'Tomorrow'",
    nextWeek: "'",
    other: "'",
};

// TODO check if we really need this locale and specifc this enUS
const locale = {
    ...enUS,
    formatRelative: token => formatRelativeLocale[token],
};

/**
 *
 * @returns Returns `"Yesterday"`, `"Today"` or `"Tomorrow"` if `date` is within a day of the current date. If not, returns an empty string.
 */
export const formatRelativeToToday = (date: Date) => formatRelative(date, new Date(), { locale });
